import React, { useEffect, useState, useRef } from 'react';
import Countdown from 'react-countdown';
import { Link } from 'react-router-dom';

const ItemCurrent = (props) => {

    const [state, setState] = useState({
        data: props.data,
        loader: true,
        rank: ['اول', 'دوم', 'سوم'],
        days: '0',
        hours: '00',
        minutes: '00'
    })

    const Days = useRef(0);
    const Hours = useRef(0);
    const Minutes = useRef(0);

    // Renderer callback with condition
    const timerRender = ({ days, hours, minutes, completed }) => {
        if (Days.current.innerText != undefined &&
            Hours.current.innerText != undefined &&
            Minutes.current.innerText != undefined) {
            Days.current.innerText = days
            Hours.current.innerText = (hours == 0 ? '00' : hours)
            Minutes.current.innerText = (minutes == 0 ? '00' : minutes)
        }
        if (completed) {
            return (
                <>
                    <span>00</span>
                    <span>00</span>
                    <span>0</span>
                </>
            );
        } else {
            // Render a countdown
            return <span>{days}:{hours}:{minutes}</span>;
        }
    };

    return (
        <div className="item-current">
            <div className="details-lattery">
                <div className="body-lottery">
                    <h4>{state.data.title}</h4>
                    <span>
                    {/* وضعیت شما : <b>{state.data.show_result}</b> */}
                    </span>
                    <div className="remain-time">
                        <div className="time">
                            <div className={`times ${state.data == null ? '' : state.data.time_secound <= 86400 ? 'expire' : ''}`}>
                                <div className="conter">
                                    <span ref={Days} >{state.days}</span>
                                    <span>روز</span>
                                </div>
                                <div className="conter">
                                    <span ref={Hours}>{state.hours}</span>
                                    <span>ساعت</span>
                                </div>
                                <div className="conter">
                                    <span ref={Minutes}>{state.minutes}</span>
                                    <span>دقیقه</span>
                                </div>
                                <div className="cmpnt-timer">
                                    {state.data == null ?
                                        null
                                        :
                                        <Countdown
                                            date={Date.now() + (state.data.time_secound <= 0 ? 0 : state.data.time_secound * 1000)}
                                            renderer={timerRender} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Link to={`/lottery/${state.data.result_status ? 'expired' : 'details'}/${state.data.id}`} className="title-ltr">جزییات قرعه کشی</Link>
                </div>
            </div>
        </div>
    );
}

export default ItemCurrent;